import { render, staticRenderFns } from "./MpMendelejew.vue?vue&type=template&id=3cc8fd09&scoped=true&"
import script from "./MpMendelejew.vue?vue&type=script&lang=js&"
export * from "./MpMendelejew.vue?vue&type=script&lang=js&"
import style1 from "./MpMendelejew.vue?vue&type=style&index=1&id=3cc8fd09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc8fd09",
  null
  
)

export default component.exports